export default __webpack_public_path__ + "static/media/bg2.96bf7693.png";